export default "__VITE_ASSET__b81e039f__"